export default {
	HelloWorld: 'HelloWorld en',
}
